module.exports = __webpack_public_path__ + "static/img/2bc.d49b6b91.webp";